function closeFancybox() {
    parent.$.fancybox.close();
    setTimeout(function () {
        parent.$.fancybox.close();
    }, 200);
}

function initFlatpickr(setting) {
    if (typeof setting === 'undefined') {
        setting = {};
    }

    $(".js-date").flatpickr(
        $.extend({
            locale: $('[data-app-lang]').data('app-lang'),
            altInput: true,
            altFormat: "d.m.Y",
            dateFormat: "Y-m-d",
        }, setting)
    );
}


function initSelect2() {
    $('.js-select2').select2({
        escapeMarkup: function (markup) {
            return markup;
        }
    });
}

function initTooltip(){
    $('[data-toggle="tooltip"]').tooltip()
}

function trimInputs() {
    $(document).on('change paste', 'input, textarea', function () {
        var str = $.trim($(this).val());
        $(this).val(str);
        $(this).attr("value", str);
    });
}

function get_scrollTop() {
    if ($("html").scrollTop()) return $("html").scrollTop();
    if ($("body").scrollTop()) return $("body").scrollTop();
    return 0;
}


function rendered() {

}

function startRender() {
    requestAnimationFrame(rendered);
}

function loaded() {
    requestAnimationFrame(startRender);
}

function isMobile() {
    return window.matchMedia('(max-width: 1049px)').matches;
}

// Expose legacy helpers globally for Twig inline scripts and for
// module-bundled code (ESM doesn't get implicit global bindings).
if (typeof window !== 'undefined') {
    window.closeFancybox = closeFancybox;
    window.initFlatpickr = initFlatpickr;
    window.initSelect2 = initSelect2;
    window.initTooltip = initTooltip;
    window.trimInputs = trimInputs;
    window.get_scrollTop = get_scrollTop;
    window.rendered = rendered;
    window.startRender = startRender;
    window.loaded = loaded;
    window.isMobile = isMobile;
}